export const queryKey = {
  homeTabs: () => ['homeTabs'],
  homeIcons: () => ['homeIcons'],
} as const;
